
import { getVersionString, IS_BETA } from "@/constants/version";
import { cn } from "@/lib/utils";

interface VersionDisplayProps {
  className?: string;
  showPrefix?: boolean;
}

export function VersionDisplay({ className, showPrefix = true }: VersionDisplayProps) {
  return (
    <span className={cn("text-xs opacity-60", className)}>
      {showPrefix ? "v" : ""}{getVersionString()}
      {IS_BETA && " (Beta Release)"}
    </span>
  );
}
